.status-button-container {
    display: flex;
    align-items: center;
}

.status-button-icon {
    line-height: 0;
    margin-right: 8px;
}

.status-popover {
    width: 400px;
}
